export default __webpack_public_path__ + "static/media/SG-Yellow-0003.100b7e57.png";